import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=4e512458&scoped=true"
import script from "./pop.vue?vue&type=script&lang=js"
export * from "./pop.vue?vue&type=script&lang=js"
import style0 from "./pop.vue?vue&type=style&index=0&id=4e512458&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e512458",
  null
  
)

export default component.exports